import { SvgIconProps } from '@mui/material';

export const FeaturedIcon = (props: SvgIconProps) => {
  return (
    <svg {...props} fill="none" viewBox="0 0 56 56"  xmlns="http://www.w3.org/2000/svg">
      <circle cx="28" cy="28" fill="#F5F5FF" r="28" />
      <circle cx="28" cy="28" fill="#E7E7FC" r="20" />
      <path d="M36 22L25 33L20 28" stroke="#0909A2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    </svg>
  );
};
